/*******************************************************
OPEN WIN RATE SEASON MODAL
Used on the win rate page for NFL.
********************************************************/

import buildModal from '../../universal/modal-window/build-modal';

export default function openWinRateBySeasonModal(event) {
    const $button = $(event.currentTarget);
    const { id, playerid, firstname, lastname, pos, team, startweek, endweek } = $button.data();

    // Set the table loading message
    const loadingMessage = `Loading ${firstname} ${lastname} Stats`;

    // Build the title
    const modalTitle = `
    <div class="flex-row align-center">
        <img style="width:35px;margin-right:10px;" src="https://content.rotowire.com/images/teamlogo/football/100${team}.png"> ${firstname} ${lastname}
    </div>`;

    // Build the content of the modal
    const modalContent = `
        <div id="win-rate-table${playerid}">
            <div class="table-load"><div class="table-load__inner"><div class="loader"></div>${loadingMessage}</div></div>
        </div>`;

    // Get the modal window HTML
    const modalHTML = buildModal({
        title    : modalTitle,
        content  : modalContent,
    });

    // Append the modal window to the page
    $('.page').append(modalHTML);

    loadTableRW({
        container   : `win-rate-table${playerid}`,
        url         : `/football/tables/win-rate-player.php?&playerid=${playerid}`,
        emptyMessage: 'We do not have any stats to display at the moment.',
        leftSplit   : 1,
        css         : 'no-border',
        columns     : [

            { id: 'player',
            header: [{ text: 'Player', css: 'align-l' },],
            sort: 'linked-name', sortDirection: 'asc',
            template: function (player) {
                return '<a href="' + player.URL + '"><span class="hide-until-xs">' + player.firstname + '</span><span class="hide-xs-up">' + player.firstname[0] + '.</span> ' + player.lastname + '</a>';
            },
            },
            { id: 'team',
            header: [{ text: 'Team' }, ],
            sort: 'text-string',
            },
            { id: 'pos',
            header: [{ text: 'Pos' }, ],
            sort: 'text-string',
            },
            { id: 'season',
            header: [{ text: 'Season' }, ],
            sort: 'number', sortDirection: 'asc',
            },
            { id: 'winPct',
            header: [{ text: 'Win %' }, ],
            sort: 'number'
            },
            { id: 'adp',
            header: [{ text: 'ADP' }, ],
            sort: 'number', sortDirection: 'asc',
            },
            { id: 'fpts',
            header: [{ text: 'FPTS' }, ],
            sort: 'number'
            },
            { id: 'score',
            header: [{ text: 'Avg Score' }, ],
            sort: 'number'
            },

        ],
    });
}
